export default __webpack_public_path__ + "static/media/logo_original_small.1b69356e.png";